import axios from 'axios'
export default {
  index(params) {
    const { page, rowsPerPage, sucursal_uuid } = params;

    let baseUrl = `/comprobantes/comprobantes?esVenta=false&doc=RE&page=${page}&page_size=${rowsPerPage}`;

    if (sucursal_uuid) {
      baseUrl += `&uuid_sucursal=${sucursal_uuid}`;
    }

    return axios.get(baseUrl);
  },

  show(id) {
    var url = `/comprobantes/compra/remito/${id}`
    return axios.get(url);


  },

  update(id, data) {

  },

  create(data) {
    var url = '/comprobantes/compra/remito'
    return axios.post(url, data)

  },
  getRemitosPendientes(paginacion) {

    var url = `/comprobantes/compra/remito?estado=PENDIENTE&page=${paginacion.page}&page_size=${paginacion.rowsPerPage}`;


    return axios.get(url);
  }



}